import React, { useRef, Suspense, lazy, useEffect } from "react";
import styles from "../styles/screens/Homescreen.module.css";
//import { Link /*useNavigate*/ } from "react-router-dom";
//import { useTranslation } from "react-i18next";
import NavBar from "../components/Navbar";
import Footer from "../components/Footer";
import Download from "../components/Download";
//import splashImage from "../assets/background/splash.png";
import { usePostHog } from "posthog-js/react";
import Metadata from "../components/metadata/MetaData";
import { limitedLaunches } from '../utils/ImageUrlData';

const LatestBookPuja = lazy(() =>
  import("../components/bookpuja/LatesBookPuja")
);
const Customer = lazy(() => import("../components/Customer"));
const CarouselReuse = lazy(() =>
  import("../components/NewLaunches/CarouselReuse")
);

function HomeScreen() {

  const posthog = usePostHog();
  //const navigate = useNavigate();
  const bookPujaRef = useRef(null);
  //const { t } = useTranslation();

  useEffect(() => {
    // Capture pageview
    posthog.capture("$pageview");

    // Check if user is logged in
    const phoneNumber = JSON.parse(localStorage.getItem("phoneNumber"));

    if (phoneNumber) {
      // Identify user if logged in
      posthog.identify(phoneNumber, {
        phone: phoneNumber,
        platform: "web",
        category: "web_user",
      });

      // Set user properties
      posthog.people.set({
        phone: phoneNumber,
        platform: "web",
        category: "web_user",
      });
    }
  }, [posthog]);

  return (
    <div>
      <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
      />
      <NavBar bookPujaRef={bookPujaRef} />
      <div className={styles.marquee_container}>
        <p className={styles.marquee_text}>
          Trusted by 1 million+ people | India's Largest App for Hindu Devotees | 100% Authentic and Secure
        </p>
      </div>
      <div className={styles.banner_container}>
        <div 
          className={styles.banner_image}
          onClick={() => bookPujaRef.current.scrollIntoView({ behavior: "smooth" })}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="https://d3vqmpzcil03dt.cloudfront.net/dharmikx/website-assets/mainbanne.webp"
            alt="Hanuman Jayanti 2025"
            className={styles.banner_img}
          />
        </div>
      </div>
      <div style={{marginTop:"-35px"}}>
        <Suspense>
          <div id="limited-launches">
            <CarouselReuse
              title="Limited Launches"
              subtitle="Amrit Jal Perfume (Rose Fragrance)"
              description="First perfume to be made from Triveni Sangam Jal of Mahakumbh'25"
              images={limitedLaunches}
              link="dharmikx/product/amritjal-rose"
              delay={0}
            />
          </div>
        </Suspense>
        {/* <Suspense>
          <div id="mahakumbh-jal">
            <CarouselReuse
              title="MahaKumbh Jal"
              description="Pure , Authentically sourced from Triveni Sangam of Mahakumbh '25"
              images={mahagunJal}
              link="dharmikx/product/amritjal-spray"
              delay={1500}
            />
          </div>
        </Suspense> */}
        {/* <Suspense>
          <div id="rishikesh-getaway">
            <CarouselReuse
              title="Weekend Rishikesh"
              titleOne="Gateway"
              images={weekendRishikesh}
              link="dharmikx/trip-to-hidden-gems"
              delay={1800}
            />
          </div>
        </Suspense> */}
      </div>
      <div ref={bookPujaRef}>
        <Suspense>
        <div id="prasad-boxes">
            <LatestBookPuja title="Prasad Boxes & Gifts" categoryFilter={false} delay={0}/>
          </div>
          <div id="book-puja">
            <LatestBookPuja title="Book Puja's" categoryFilter={true} delay={1500}/>
          </div>
        </Suspense>
      </div>
      <Suspense>
        <Customer reviewFile={"homepage_review.json"}/>
      </Suspense>
      {/* <br></br> */}
      {/* <br></br> */}
      <Download />
      <Footer />
    </div>
  );
}

export default HomeScreen;
